export interface RouteSEO {
  path: string;
  title: string;
  desc: string;
  keywords: string;
  category?: string;
}

export const BASE_URL = "https://kmwadvertising.com";
export const DEFAULT_OG_IMAGE = `${BASE_URL}/images/kmwa_logo.png`;

export const seoRegistry: Record<string, RouteSEO> = {
  "/": {
    path: "/",
    title: "KMWA — Kris Media Work Advertising · 360° Digital Agency",
    desc: "KMWAdvertising LLP is a full-funnel digital advertising and media buying agency. We craft high-ROI performance campaigns, omnichannel branding, web applications, and precision creative systems that accelerate business growth.",
    keywords: "advertising agency, digital marketing, media buying, performance marketing, branding agency Mumbai, 360 advertising, Kris Media Works, KMWA",
    category: "Advertising & Marketing Agency",
  },
  "/about-us": {
    path: "/about-us",
    title: "About Us — KMWAdvertising LLP · 25+ Years of Advertising Excellence",
    desc: "Learn about KMWAdvertising LLP's 25+ years legacy in strategic media buying, integrated advertising, creative storytelling, and omnichannel growth frameworks.",
    keywords: "about KMWA, advertising agency Mumbai, media planning experts, marketing leaders, KMWAdvertising history",
    category: "About",
  },
  "/services": {
    path: "/services",
    title: "Our Advertising & Strategic Services — KMWAdvertising LLP",
    desc: "Explore full-spectrum advertising solutions across Traditional Media, Digital Advertising, Branding & Creative Production, and Strategic Research & Consulting.",
    keywords: "advertising services, media buying, SEO, performance marketing, TV ads, radio ads, branding, digital agency services",
    category: "Services Overview",
  },
  "/work": {
    path: "/work",
    title: "Industries & Case Work — KMWAdvertising · Strategic Media Systems",
    desc: "Discover vertical-specific media systems built for Gaming & iGaming, FMCG, Real Estate, Healthcare, D2C, Hospitality, and Enterprise B2B.",
    keywords: "advertising case studies, industry marketing, gaming ad strategy, FMCG advertising, real estate marketing",
    category: "Industries",
  },
  "/industries": {
    path: "/industries",
    title: "Industries We Scale — KMWAdvertising · Vertical Growth Frameworks",
    desc: "Explore how KMWAdvertising designs high-converting, vertical-specific media engines tailored to industry dynamics, regulatory compliance, and audience behaviors.",
    keywords: "industries served, vertical advertising, B2B media buying, retail marketing, fintech advertising",
    category: "Industries",
  },
  "/process": {
    path: "/process",
    title: "Our 6-Step Growth System & Execution Process — KMWAdvertising",
    desc: "From formulation and audience diagnostics to cross-channel deployment and algorithmic optimization, see how KMWA delivers predictable ROI.",
    keywords: "advertising process, media planning workflow, growth framework, campaign optimization system",
    category: "Process",
  },
  "/blogs": {
    path: "/blogs",
    title: "Blogs & Market Insights — KMWAdvertising LLP",
    desc: "Expert analysis, performance marketing guides, media planning strategies, and brand design trends from the specialists at KMWAdvertising.",
    keywords: "advertising blog, marketing trends, media buying guides, ad tech insights",
    category: "Insights",
  },
  "/contact-us": {
    path: "/contact-us",
    title: "Contact Us — KMWAdvertising LLP · Start Your Campaign",
    desc: "Get in touch with KMWAdvertising LLP to plan your next advertising campaign, media audit, or digital transformation. Direct phone, email, and WhatsApp support.",
    keywords: "contact KMWA, hire ad agency, advertising quote, media planning inquiry, Mumbai advertising office",
    category: "Contact",
  },

  // Traditional Media
  "/service/television-advertising-services": {
    path: "/service/television-advertising-services",
    title: "Television Advertising Services — KMWAdvertising",
    desc: "Prime-time TV ad spots, regional broadcast campaigns, TRP-backed media planning, and national brand reach with KMWAdvertising.",
    keywords: "TV advertising, television commercials, TV media buying, broadcast advertising India, prime time ad slots",
    category: "Traditional Media",
  },
  "/services/television-advertising-services": {
    path: "/services/television-advertising-services",
    title: "Television Advertising Services — KMWAdvertising",
    desc: "Prime-time TV ad spots, regional broadcast campaigns, TRP-backed media planning, and national brand reach with KMWAdvertising.",
    keywords: "TV advertising, television commercials, TV media buying, broadcast advertising India",
    category: "Traditional Media",
  },
  "/service/radio-advertising-services": {
    path: "/service/radio-advertising-services",
    title: "Radio Advertising Services — KMWAdvertising",
    desc: "High-frequency radio jingles, RJ mentions, city-targeted broadcast campaigns, and regional audio advertising solutions.",
    keywords: "radio advertising, FM radio ads, radio jingle production, RJ endorsements, audio media buying",
    category: "Traditional Media",
  },
  "/services/radio-advertising-services": {
    path: "/services/radio-advertising-services",
    title: "Radio Advertising Services — KMWAdvertising",
    desc: "High-frequency radio jingles, RJ mentions, city-targeted broadcast campaigns, and regional audio advertising solutions.",
    keywords: "radio advertising, FM radio ads, radio jingle production, RJ endorsements",
    category: "Traditional Media",
  },
  "/service/print-advertisements-services": {
    path: "/service/print-advertisements-services",
    title: "Print Advertisements Services — KMWAdvertising",
    desc: "Leading newspaper jacket ads, full-page insertions, regional press buying, and trade magazine advertising campaigns.",
    keywords: "print advertising, newspaper ads, magazine advertisements, front page jacket ads, press media buying",
    category: "Traditional Media",
  },
  "/services/print-advertisements-services": {
    path: "/services/print-advertisements-services",
    title: "Print Advertisements Services — KMWAdvertising",
    desc: "Leading newspaper jacket ads, full-page insertions, regional press buying, and trade magazine advertising campaigns.",
    keywords: "print advertising, newspaper ads, magazine advertisements, press media buying",
    category: "Traditional Media",
  },
  "/dev/service/print-advertisements-services": {
    path: "/dev/service/print-advertisements-services",
    title: "Print Advertisements Services — KMWAdvertising",
    desc: "Leading newspaper jacket ads, full-page insertions, regional press buying, and trade magazine advertising campaigns.",
    keywords: "print advertising, newspaper ads, magazine advertisements",
    category: "Traditional Media",
  },
  "/service/cinema-advertising-services": {
    path: "/service/cinema-advertising-services",
    title: "Cinema Advertising Services — KMWAdvertising",
    desc: "Multiplex on-screen commercials, cinema lobby branding, audio-visual theatre ads, and captive blockbuster audience reach.",
    keywords: "cinema advertising, multiplex theatre ads, on-screen commercials, PVR INOX ad spots, movie screen ads",
    category: "Traditional Media",
  },
  "/services/cinema-advertising-services": {
    path: "/services/cinema-advertising-services",
    title: "Cinema Advertising Services — KMWAdvertising",
    desc: "Multiplex on-screen commercials, cinema lobby branding, audio-visual theatre ads, and captive blockbuster audience reach.",
    keywords: "cinema advertising, multiplex theatre ads, on-screen commercials, movie screen ads",
    category: "Traditional Media",
  },
  "/dev/service/cinema-advertising-services": {
    path: "/dev/service/cinema-advertising-services",
    title: "Cinema Advertising Services — KMWAdvertising",
    desc: "Multiplex on-screen commercials, cinema lobby branding, audio-visual theatre ads, and captive blockbuster audience reach.",
    keywords: "cinema advertising, multiplex theatre ads, on-screen commercials",
    category: "Traditional Media",
  },
  "/services/outdoor-advertising-services": {
    path: "/services/outdoor-advertising-services",
    title: "Outdoor & OOH Advertising Services — KMWAdvertising",
    desc: "Billboards, digital DOOH screens, airport displays, metro transit wraps, and high-visibility outdoor media infrastructure.",
    keywords: "outdoor advertising, OOH media, billboards, digital OOH, airport branding, transit media ads",
    category: "Traditional Media",
  },

  // Research & Consulting
  "/services/research-consulting-services": {
    path: "/services/research-consulting-services",
    title: "Research & Consulting Services — KMWAdvertising",
    desc: "Data-backed market research, competitive intelligence, consumer behavior analysis, and strategic marketing consulting.",
    keywords: "marketing research, consulting services, competitive analysis, market intelligence, consumer research",
    category: "Research & Consulting",
  },
  "/services/research-consulting-and-media-audit-services": {
    path: "/services/research-consulting-and-media-audit-services",
    title: "Media Audit Services — KMWAdvertising",
    desc: "Independent evaluation of media buying rates, delivery verification, budget allocation audits, and waste-reduction frameworks.",
    keywords: "media audit, advertising audit, media buying efficiency, ad spend verification, rate benchmarking",
    category: "Research & Consulting",
  },
  "/services/research-consulting-and-brand-audit-services": {
    path: "/services/research-consulting-and-brand-audit-services",
    title: "Brand Audit Services — KMWAdvertising",
    desc: "Holistic brand health assessments, visual identity perception audits, positioning analysis, and customer sentiment evaluation.",
    keywords: "brand audit, brand equity analysis, market positioning assessment, brand perception study",
    category: "Research & Consulting",
  },
  "/services/research-consulting-and-campaign-audit-services": {
    path: "/services/research-consulting-and-campaign-audit-services",
    title: "Campaign Audit Services — KMWAdvertising",
    desc: "Comprehensive cross-channel campaign diagnostics, conversion attribution checks, ROI evaluation, and performance gap analysis.",
    keywords: "campaign audit, ad performance evaluation, marketing ROI analysis, conversion attribution",
    category: "Research & Consulting",
  },

  // Digital Media
  "/services/performance-marketing-services": {
    path: "/services/performance-marketing-services",
    title: "Performance Marketing Services — KMWAdvertising",
    desc: "Data-engineered Google Search/Display ads, Meta Paid Social, high-intent audience funnels, and ROAS-focused media scaling.",
    keywords: "performance marketing, Google ads, Meta ads, Facebook ads, PPC agency, ROAS optimization",
    category: "Digital Media",
  },
  "/services/ott-advertising-services": {
    path: "/services/ott-advertising-services",
    title: "OTT & Connected TV Advertising — KMWAdvertising",
    desc: "Targeted video advertising across JioCinema, Disney+ Hotstar, SonyLIV, YouTube Connected TV, and top streaming apps.",
    keywords: "OTT advertising, connected TV ads, streaming video ads, Hotstar ad placement, CTV campaigns",
    category: "Digital Media",
  },
  "/services/programmatic-advertising-services": {
    path: "/services/programmatic-advertising-services",
    title: "Programmatic Advertising Services — KMWAdvertising",
    desc: "Automated DSP ad purchasing, real-time bidding (RTB), audience retargeting, and contextual display across premium global networks.",
    keywords: "programmatic advertising, DSP media buying, real time bidding, programmatic display ads, ad exchange",
    category: "Digital Media",
  },
  "/services/orm-services": {
    path: "/services/orm-services",
    title: "Online Reputation Management (ORM) — KMWAdvertising",
    desc: "Proactive brand sentiment monitoring, crisis mitigation, review optimization, and corporate search result enhancement.",
    keywords: "online reputation management, ORM services, brand reputation, negative review management, search suppression",
    category: "Digital Media",
  },
  "/services/ai-marketing-services": {
    path: "/services/ai-marketing-services",
    title: "AI Marketing & Automation Services — KMWAdvertising",
    desc: "Predictive consumer behavior modeling, AI dynamic creative personalization, automated bidding algorithms, and intelligent workflows.",
    keywords: "AI marketing, artificial intelligence advertising, marketing automation, predictive analytics",
    category: "Digital Media",
  },
  "/services/web-development-services": {
    path: "/services/web-development-services",
    title: "Web Development & UX Engineering — KMWAdvertising",
    desc: "High-performance React/Next.js web applications, conversion-optimized landing pages, e-commerce storefronts, and bespoke UI/UX.",
    keywords: "web development, custom website design, landing page optimization, React web design, UI UX agency",
    category: "Digital Media",
  },
  "/services/email-marketing-services": {
    path: "/services/email-marketing-services",
    title: "Email Marketing & Lifecycle Automation — KMWAdvertising",
    desc: "High-deliverability email campaigns, behavioral trigger sequences, churn reduction workflows, and customer lifetime value expansion.",
    keywords: "email marketing, newsletter campaigns, lifecycle automation, Klaviyo marketing, lead nurturing",
    category: "Digital Media",
  },
  "/services/analytics-services": {
    path: "/services/analytics-services",
    title: "Marketing Analytics & Attribution — KMWAdvertising",
    desc: "End-to-end data pipeline setup, Google Analytics 4, server-side tracking, multi-touch attribution, and real-time executive dashboards.",
    keywords: "marketing analytics, GA4 setup, conversion tracking, multi-touch attribution, data dashboards",
    category: "Digital Media",
  },
  "/services/data-intelligence-services": {
    path: "/services/data-intelligence-services",
    title: "Data Intelligence & Consumer Insights — KMWAdvertising",
    desc: "Deep customer profiling, geo-spatial intent modeling, first-party data activation, and market trend forecasts.",
    keywords: "data intelligence, consumer insights, first party data, audience segmentation, market modeling",
    category: "Digital Media",
  },
  "/services/display-native-ads-services": {
    path: "/services/display-native-ads-services",
    title: "Display & Native Ads Services — KMWAdvertising",
    desc: "Rich media responsive banners, publisher native recommendations, high-CTR interactive formats, and brand awareness networks.",
    keywords: "display advertising, native ads, banner advertising, sponsored content, Taboola Outbrain ads",
    category: "Digital Media",
  },
  "/services/app-advertising-services": {
    path: "/services/app-advertising-services",
    title: "App Advertising & User Acquisition — KMWAdvertising",
    desc: "Cost-effective iOS & Android app installs, App Store Optimization (ASO), in-app re-engagement, and cohort retention campaigns.",
    keywords: "app advertising, mobile user acquisition, App Store Optimization, CPI marketing, app installs",
    category: "Digital Media",
  },
  "/services/seo-services": {
    path: "/services/seo-services",
    title: "SEO Services (Search Engine Optimization) — KMWAdvertising",
    desc: "Technical SEO audits, high-intent keyword mapping, semantic content optimization, authority link building, and local Mumbai SEO.",
    keywords: "SEO services, search engine optimization, technical SEO, organic traffic growth, SEO agency Mumbai",
    category: "Digital Media",
  },
  "/services/social-media-marketing-services": {
    path: "/services/social-media-marketing-services",
    title: "Social Media Marketing (SMM) — KMWAdvertising",
    desc: "Full-funnel organic and paid social strategies across Instagram, LinkedIn, YouTube, Facebook, and Twitter/X.",
    keywords: "social media marketing, Instagram management, LinkedIn B2B marketing, viral content, social media agency",
    category: "Digital Media",
  },
  "/services/cro-services": {
    path: "/services/cro-services",
    title: "Conversion Rate Optimization (CRO) — KMWAdvertising",
    desc: "User session recordings, heatmaps, multivariate A/B testing, funnel drop-off diagnostics, and checkout friction elimination.",
    keywords: "CRO services, conversion rate optimization, A/B testing, landing page conversion, UX optimization",
    category: "Digital Media",
  },

  // Branding & Creatives
  "/services/branding-creatives-and-brand-strategy-services": {
    path: "/services/branding-creatives-and-brand-strategy-services",
    title: "Branding & Strategy Services — KMWAdvertising",
    desc: "Complete brand architecture, unique value proposition formulation, brand voice guidelines, and market positioning strategy.",
    keywords: "branding strategy, brand positioning, brand architecture, corporate identity, brand storytelling",
    category: "Branding & Creatives",
  },
  "/services/branding-creatives-and-logo-identity-services": {
    path: "/services/branding-creatives-and-logo-identity-services",
    title: "Logo Design & Visual Identity Systems — KMWAdvertising",
    desc: "Iconic corporate logos, typography systems, color theory guidelines, brand books, and scalable visual design assets.",
    keywords: "logo design, visual identity, corporate brand guidelines, brand book design, icon design",
    category: "Branding & Creatives",
  },
  "/services/branding-creatives-and-motion-ai-video-services": {
    path: "/services/branding-creatives-and-motion-ai-video-services",
    title: "Motion Graphics & AI Video Creation — KMWAdvertising",
    desc: "Dynamic motion graphics, 3D product animations, AI-generated video campaigns, and high-retention social video creative.",
    keywords: "motion graphics, AI video creation, 3D animation, social video ads, animated commercials",
    category: "Branding & Creatives",
  },
  "/services/branding-creatives-and-video-production-services": {
    path: "/services/branding-creatives-and-video-production-services",
    title: "Video Production & Brand Films — KMWAdvertising",
    desc: "High-production TVCs, corporate brand films, founder documentaries, product showcases, and full post-production editing.",
    keywords: "video production, TVC production, corporate films, commercial shoot, ad filmmaking Mumbai",
    category: "Branding & Creatives",
  },
  "/services/branding-creatives-and-photography-copywriting-services": {
    path: "/services/branding-creatives-and-photography-copywriting-services",
    title: "Commercial Photography & Copywriting — KMWAdvertising",
    desc: "Professional studio product photography, corporate team portraits, high-conversion copywriting, and advertising slogans.",
    keywords: "commercial photography, product photoshoot, advertising copywriting, brand copy, corporate photoshoot",
    category: "Branding & Creatives",
  },
  "/services/branding-creatives-and-campaign-design-services": {
    path: "/services/branding-creatives-and-campaign-design-services",
    title: "360° Integrated Campaign Design — KMWAdvertising",
    desc: "Omnichannel creative design packages connecting billboards, digital ads, social key visuals, print ads, and retail POS collateral.",
    keywords: "campaign design, integrated marketing campaign, 360 creative design, advertising key visual, omnichannel branding",
    category: "Branding & Creatives",
  },
  "/services/branding-creatives-and-office-branding-services": {
    path: "/services/branding-creatives-and-office-branding-services",
    title: "Corporate Office & Environmental Branding — KMWAdvertising",
    desc: "Workplace wall graphics, lobby brand installations, wayfinding signage, and immersive branded physical environments.",
    keywords: "office branding, environmental graphics, workplace wall murals, corporate signage, spatial branding",
    category: "Branding & Creatives",
  },
};

export function getRouteSEO(pathname: string): RouteSEO {
  const cleanPath = pathname.replace(/\/$/, "") || "/";
  if (seoRegistry[cleanPath]) {
    return seoRegistry[cleanPath];
  }
  const altKey = Object.keys(seoRegistry).find((k) => k === cleanPath || cleanPath.endsWith(k));
  if (altKey) {
    return seoRegistry[altKey];
  }

  return {
    path: cleanPath,
    title: "KMWAdvertising LLP · 360° Digital Agency",
    desc: "KMWAdvertising LLP builds high-ROI performance marketing campaigns, omnichannel media buying, web engineering, and brand ecosystems.",
    keywords: "advertising agency, digital marketing, media buying, performance marketing, KMWAdvertising",
    category: "Advertising",
  };
}

export function generateSchemaJSON(seo: RouteSEO) {
  const canonicalUrl = `${BASE_URL}${seo.path === "/" ? "" : seo.path}`;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${BASE_URL}/#organization`,
        "name": "KMWAdvertising LLP",
        "url": BASE_URL,
        "logo": {
          "@type": "ImageObject",
          "url": DEFAULT_OG_IMAGE,
          "caption": "KMWAdvertising LLP Logo",
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91-98923-98474",
          "contactType": "Customer Service",
          "email": "sadia@krismediaworks.com",
          "areaServed": "IN",
          "availableLanguage": [
            "English",
            "Hindi"
          ],
        },
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Mumbai",
          "addressCountry": "IN",
        },
        "sameAs": [
          "https://www.linkedin.com/company/kmwadvertising/?viewAsMember=true"
        ],
      },
      {
        "@type": "WebSite",
        "@id": `${BASE_URL}/#website`,
        "url": BASE_URL,
        "name": "KMWAdvertising LLP",
        "publisher": {
          "@id": `${BASE_URL}/#organization`,
        },
      },
      {
        "@type": "WebPage",
        "@id": `${canonicalUrl}#webpage`,
        "url": canonicalUrl,
        "name": seo.title,
        "description": seo.desc,
        "isPartOf": {
          "@id": `${BASE_URL}/#website`,
        },
        "about": {
          "@id": `${BASE_URL}/#organization`,
        },
      },
    ],
  };
}
